var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersTestImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    fill: "#EEF4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.631836,
    width: 111,
    height: 111,
    rx: 15.5,
    stroke: "#C7D7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 36.7985C26 33.0648 26 31.198 26.7266 29.7719C27.3658 28.5175 28.3856 27.4976 29.6401 26.8585C31.0661 26.1318 32.933 26.1318 36.6667 26.1318H38.6667C42.4003 26.1318 44.2672 26.1318 45.6933 26.8585C46.9477 27.4976 47.9676 28.5175 48.6067 29.7719C49.3333 31.198 49.3333 33.0648 49.3333 36.7985V38.7985C49.3333 42.5322 49.3333 44.399 48.6067 45.8251C47.9676 47.0795 46.9477 48.0994 45.6933 48.7385C44.2672 49.4652 42.4003 49.4652 38.6667 49.4652H36.6667C32.933 49.4652 31.0661 49.4652 29.6401 48.7385C28.3856 48.0994 27.3658 47.0795 26.7266 45.8251C26 44.399 26 42.5322 26 38.7985V36.7985Z",
    stroke: "#4C60E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73.4652C26 69.7315 26 67.8646 26.7266 66.4386C27.3658 65.1842 28.3856 64.1643 29.6401 63.5251C31.0661 62.7985 32.933 62.7985 36.6667 62.7985H38.6667C42.4003 62.7985 44.2672 62.7985 45.6933 63.5251C46.9477 64.1643 47.9676 65.1842 48.6067 66.4386C49.3333 67.8646 49.3333 69.7315 49.3333 73.4652V75.4652C49.3333 79.1989 49.3333 81.0657 48.6067 82.4918C47.9676 83.7462 46.9477 84.7661 45.6933 85.4052C44.2672 86.1318 42.4003 86.1318 38.6667 86.1318H36.6667C32.933 86.1318 31.0661 86.1318 29.6401 85.4052C28.3856 84.7661 27.3658 83.7462 26.7266 82.4918C26 81.0657 26 79.1989 26 75.4652V73.4652Z",
    stroke: "#4C60E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6667 36.7985C62.6667 33.0648 62.6667 31.198 63.3933 29.7719C64.0324 28.5175 65.0523 27.4976 66.3067 26.8585C67.7328 26.1318 69.5996 26.1318 73.3333 26.1318H75.3333C79.067 26.1318 80.9339 26.1318 82.3599 26.8585C83.6144 27.4976 84.6342 28.5175 85.2734 29.7719C86 31.198 86 33.0648 86 36.7985V38.7985C86 42.5322 86 44.399 85.2734 45.8251C84.6342 47.0795 83.6144 48.0994 82.3599 48.7385C80.9339 49.4652 79.067 49.4652 75.3333 49.4652H73.3333C69.5996 49.4652 67.7328 49.4652 66.3067 48.7385C65.0523 48.0994 64.0324 47.0795 63.3933 45.8251C62.6667 44.399 62.6667 42.5322 62.6667 38.7985V36.7985Z",
    stroke: "#4C60E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6667 73.4652C62.6667 69.7315 62.6667 67.8646 63.3933 66.4386C64.0324 65.1842 65.0523 64.1643 66.3067 63.5251C67.7328 62.7985 69.5996 62.7985 73.3333 62.7985H75.3333C79.067 62.7985 80.9339 62.7985 82.3599 63.5251C83.6144 64.1643 84.6342 65.1842 85.2734 66.4386C86 67.8646 86 69.7315 86 73.4652V75.4652C86 79.1989 86 81.0657 85.2734 82.4918C84.6342 83.7462 83.6144 84.7661 82.3599 85.4052C80.9339 86.1318 79.067 86.1318 75.3333 86.1318H73.3333C69.5996 86.1318 67.7328 86.1318 66.3067 85.4052C65.0523 84.7661 64.0324 83.7462 63.3933 82.4918C62.6667 81.0657 62.6667 79.1989 62.6667 75.4652V73.4652Z",
    stroke: "#4C60E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersTestImg);
export default __webpack_public_path__ + "static/media/persTestImg.5092c8e1e4709f3c46ba057ee3173542.svg";
export { ForwardRef as ReactComponent };